import Vue from "vue";
import vuetify from "../vuetify.js";
import Accordion from "../components/accordion/Accordion.vue";

export default () => {
  const elements = document.querySelectorAll(".vue-accordion");

  if (elements) {
    elements.forEach((el) => {
      new Vue({
        el,
        vuetify,

        computed: {
          content() {
            let content = {};
            if (el.dataset.content) {
              content = JSON.parse(el.dataset.content);
            }

            return content;
          },

          icon() {
            let icon = null;
            if (el.dataset.icon) {
              icon = el.dataset.icon;
            }

            return icon;
          },

          onecolumn() {
            let onecolumn = false;
            if (el.dataset.onecolumn) {
              onecolumn = JSON.parse(el.dataset.onecolumn);
            }

            return onecolumn;
          },
        },

        render: h => h(Accordion)
      })
    });
  }
};
